import { PageContentAnimation } from '../../../components/layout';
import { AgreementReports } from './components/agreement-reports';

export function AgreementReportsRoute() {
  return (
    <PageContentAnimation>
      <AgreementReports />
    </PageContentAnimation>
  );
}
